import React, { useEffect, useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Spinner from 'common/spinner/components/spinner';
import InfiniteScroll from 'react-infinite-scroller';
import MessageTile from './message-tile';

const StyledText = styled.p`
  text-align: center;
  padding: 20px;
`;

const ScrollDiv = styled.div`
  overflow-y: scroll;
  height: ${p => p.offsetHeight ? `calc(100vh - ${p.offsetHeight}px)` : '100%'}
`;

const MessageTab = ({
  messages,
  fetchData,
  loadMore,
  isLoading,
  isNextLoading,
  hasNextData,
  title,
  intl,
  canDismiss,
  onRedirect,
  dismissMessage,
  currentPage: initialPage = 1,
  setFastPolling,
  setSlowPolling,
  isDismissing,
  enableInfiniteScroll,
  offsetHeight,
  openPlanningAndView,
  totalCount,
  connectionSuccess,
}) => {
  const [currentPage, setCurrentPage] = useState(initialPage);

  useEffect(() => {
    if (!connectionSuccess) {
      if (setFastPolling) {
        setFastPolling();
      } else {
        fetchData({ page: currentPage });
      }
    } else {
      fetchData({ page: currentPage });
    }

    return () => {
      if (!connectionSuccess && setSlowPolling) {
        setSlowPolling();
      }
    };
  }, []);

  const loadMoreData = () => {
    if (isNextLoading) {
      return;
    }
    loadMore({ page: currentPage + 1 });
    setCurrentPage(prevPage => prevPage + 1);
  };

  const renderItems = () => messages?.map(message =>
    <MessageTile
      onDismiss={dismissMessage}
      key={message.correlationId}
      message={message}
      canDismiss={canDismiss}
      onRedirect={onRedirect}
      isDismissing={isDismissing}
      openPlanningAndView={openPlanningAndView}
    />,
  );


  if (isLoading) {
    return <Spinner title={intl.formatMessage({ id: `message_center.${title}` })} />;
  }

  if (messages && messages.length === 0) {
    return (
      <StyledText data-test-id='message-tab.no-messages'>
        <FormattedMessage id='message_center.NO_MESSAGES' />
      </StyledText>
    );
  }

  return (
    <ScrollDiv offsetHeight={offsetHeight}>
      {enableInfiniteScroll ?
        <InfiniteScroll
          element='div'
          loadMore={loadMoreData}
          hasMore={hasNextData || false}
          loader={messages?.length < totalCount ? <Spinner key={0} /> : null}
          useWindow={false}
          initialLoad={false}
        >
          {renderItems()}
        </InfiniteScroll> :
        renderItems()
      }
    </ScrollDiv>
  );
};

MessageTab.propTypes = {
  messages: PropTypes.array,
  fetchData: PropTypes.func,
  loadMore: PropTypes.func,
  isLoading: PropTypes.bool,
  isNextLoading: PropTypes.bool,
  hasNextData: PropTypes.bool,
  title: PropTypes.string,
  intl: PropTypes.object,
  canDismiss: PropTypes.bool,
  onRedirect: PropTypes.func,
  dismissMessage: PropTypes.func,
  currentPage: PropTypes.number,
  setFastPolling: PropTypes.func,
  setSlowPolling: PropTypes.func,
  isDismissing: PropTypes.bool,
  enableInfiniteScroll: PropTypes.bool,
  offsetHeight: PropTypes.number,
  openPlanningAndView: PropTypes.func,
  totalCount: PropTypes.number,
  connectionSuccess: PropTypes.bool,
};

export default injectIntl(MessageTab);
